/** @format */
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FullCalendarStudyEvent } from 'common-typescript/types';
import { NGXLogger } from 'ngx-logger';
import { ModalService } from 'sis-common';
import { COURSE_UNIT_INFO_MODAL } from '../../../../ajs-upgraded-modules';

@Component({
    selector: 'app-study-event-summary-modal',
    templateUrl: './study-event-summary-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudyEventSummaryModalComponent implements OnInit {
    constructor(
        private logger: NGXLogger,
        public activeModal: NgbActiveModal,
        @Inject(ModalService.injectionToken) public values: any,
        @Inject(COURSE_UNIT_INFO_MODAL) private courseUnitInfoModal: any,
    ) {}

    event: FullCalendarStudyEvent;

    ngOnInit() {
        this.event = this.values.event;
    }

    openCourseUnitInfoModal(): void {
        if (this.event?.extendedProps.enrolment) {
            const { courseUnitId } = this.event.extendedProps.enrolment;
            const { courseUnitRealisation } = this.event.extendedProps;
            if (courseUnitId) {
                this.courseUnitInfoModal
                    .showCourseUnitRealisationForCourseUnit(courseUnitId, courseUnitRealisation)
                    .then(this.activeModal.dismiss);
            } else {
                this.logger.info('courseUnit for calendar event not defined, can not open courseUnitInfoModal');
            }
        }
    }
}
